import { render, staticRenderFns } from "./text-collapse.vue?vue&type=template&id=7b225a46&"
import script from "./text-collapse.vue?vue&type=script&lang=ts&"
export * from "./text-collapse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b225a46')) {
      api.createRecord('7b225a46', component.options)
    } else {
      api.reload('7b225a46', component.options)
    }
    module.hot.accept("./text-collapse.vue?vue&type=template&id=7b225a46&", function () {
      api.rerender('7b225a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/utilities/text-collapse.vue"
export default component.exports